var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91443 12L8.19643 14.283M8.95643 8.95698L11.2394 11.239M12.0004 5.91398L14.2834 8.19598M4.54343 13.37L13.3694 4.54398C14.2224 3.69198 14.6494 3.26598 15.1394 3.10598C15.5724 2.96598 16.0374 2.96598 16.4694 3.10598C16.9604 3.26598 17.3864 3.69198 18.2374 4.54298L19.4574 5.76198C20.3094 6.61398 20.7354 7.04198 20.8954 7.53198C21.0354 7.96498 21.0354 8.42898 20.8954 8.86198C20.7354 9.35198 20.3094 9.77898 19.4574 10.632L10.6314 19.458C9.77843 20.31 9.35143 20.736 8.86143 20.896C8.42843 21.036 7.96443 21.036 7.53143 20.896C7.04143 20.736 6.61343 20.31 5.76143 19.457L4.54143 18.239C3.69143 17.387 3.26543 16.962 3.10543 16.47C2.96486 16.0378 2.96486 15.5722 3.10543 15.14C3.26543 14.65 3.69143 14.223 4.54343 13.37Z",
    stroke: "#cda742",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMaster);
export default __webpack_public_path__ + "static/media/MyMaster.47fb06b4986d05caed14772301bf9d15.svg";
export { ForwardRef as ReactComponent };